import { React, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { disableContextMenu, LoiseUsersSearch } from '../..';

function LoiseUsers(props) {
    return (
        <Box sx={{ height: '100%' }} onContextMenu={disableContextMenu}>
            <LoiseUsersSearch {...props} />
        </Box>
    );
}

export { LoiseUsers };
